import transetionBackDate from '@/api/report/transection-back-date'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
}

export const getters = {}

export const mutations = {
	...baseMutations,
}

export const actions = {
	fetch(context, attributes = {}) {
		const params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				filter: {
					search: context.state.search
				}
			},
			attributes
		)
		return transetionBackDate.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},

	transectionBackDateExcel(context, data) {
		return transetionBackDate.transectionBackDateExcel(data)
	}
}
